import classnames from "classnames";
import { ReactNode } from "react";
import { FormHelperText } from "..";
import { useStyles } from "./styles";

interface Props {
  isError?: boolean;
  children: ReactNode;
}

const InputHelpText = ({ isError = false, children }: Props): JSX.Element => {
  const styles = useStyles();
  return (
    <FormHelperText
      className={classnames(styles.description, {
        [styles.errorDescription]: isError,
      })}
      error={isError}
    >
      {children}
    </FormHelperText>
  );
};
export default InputHelpText;
